import React from "react";

import { Outlet, Navigate } from "react-router-dom";

import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import Dashboard from "../components/Dashboard/Dashboard";
import { closeSidebar } from "../components/Header/HeaderSlice";
import { useDispatch } from "react-redux";
import auth from "./auth";

export const ProtectedRoutes = () => {
  const dispatch = useDispatch();
  const outsideHandle = (e) => {
   
    dispatch(closeSidebar());
  };
  return auth.isAuthenticated() ? (
    <>
      <Header />
      <Sidebar />
      <div className="parent_class" onClick={(e) => outsideHandle(e)}>
        <Outlet />
      </div>
    </>
  ) : (
    <Navigate to="/login" />
  );
};
